//메인화면 메뉴리스트
import React, { useState, useEffect } from "react";
//MUI
import { Checkbox, MenuItem, TextField } from '@mui/material';
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Select from '@mui/material/Select';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import FormHelperText from '@mui/material/FormHelperText';

import { fni18n } from "../../services/commonService";

const date = new Date();
const now = date.toISOString().slice(0, 10);
const GROUP_TY = [
    {cd: "BIZ_TY", name: "BIZ_TY"},
    {cd: "RGN_TY", name: "RGN_TY"},
];

const BranchGroupModify = (props) => {

    const modify = props.data;
    const onParamsChange = props.onParamsChange;
    const onCheckboxChange = props.onCheckboxChange;
    const [branchGroups, setBranchGroups]=useState([{cd:'1',name:'1'},{cd:'2',name:'2'}]);

    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
        try {
            // console.log(props);
        } catch (e) {
        }
        };
        getLoadData();
    }, []);

    
    const dateFormmater = (yyyymmdd) => {
        if(!yyyymmdd)
            return;
        let date = yyyymmdd;
        if (yyyymmdd.length > 7 && yyyymmdd.length < 15) {
            const year = yyyymmdd.substring(0,4);
            const month = yyyymmdd.substring(4,6);
            const day = yyyymmdd.substring(6,8);
            const hh = yyyymmdd.substring(8,10);
            const mm = yyyymmdd.substring(10,12);
            const ss = yyyymmdd.substring(12,14);
            date = year + "-" + month + "-" + day + " " + hh + ":" + mm + ":" + ss
        }
        return date;
      }
      const regDate = dateFormmater(modify.regDt);

    return(
        <div className="pop-container">
            <div className="contents">
            <TableContainer className="table-container">
                <Table className="table" size="small">
                    <TableBody>
                    <TableRow>
                        <TableCell className="table-cell-title">{fni18n('그룹명')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="branchGroupNm"
                                value={modify.branchGroupNm||""}
                                required
                                onChange={onParamsChange}
                                variant="outlined"
                            />
                            <FormHelperText>{fni18n('필수')}</FormHelperText>
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('그룹유형')}</TableCell>
                        <TableCell className="table-cell">
                            <FormControl size="small" fullWidth={true}>
                            <Select
                                name="branchGroupTy"
                                value={modify.branchGroupTy}
                                onChange={onParamsChange}
                            >
                                {GROUP_TY.map((map)=>(
                                    <MenuItem key={map.name} value={map.name}>
                                        {map.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>{fni18n('필수')}</FormHelperText>

                            </FormControl>
                        </TableCell>
                        <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                        <TableCell className="table-cell">
                            <FormControlLabel
                                sx={{mb:0, mt:0 }}
                                control={
                                    <Checkbox
                                    name="useYn"
                                    checked={modify.useYn == "N" ? false : true}
                                    onChange={e => onCheckboxChange(e)}
                                    />
                                }
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="table-cell-title">{fni18n('설명')}</TableCell>
                        <TableCell className="table-cell">
                            <TextField
                                fullWidth
                                size="small"
                                name="description"
                                value={modify.description||""}
                                required
                                onChange={onParamsChange}
                                variant="outlined" />
                        </TableCell>
                    </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            </div>
        </div>
    );
}

export default BranchGroupModify;
